/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_ThanksInputs */

const en_ticket_review_thanks = /** @type {(inputs: Ticket_Review_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks — your review has been recorded.`)
};

const ja_ticket_review_thanks = /** @type {(inputs: Ticket_Review_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ありがとうございます — 評価を記録しました。`)
};

const fr_ticket_review_thanks = /** @type {(inputs: Ticket_Review_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci — votre évaluation a été enregistrée.`)
};

const de_ticket_review_thanks = /** @type {(inputs: Ticket_Review_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke — Ihre Bewertung wurde gespeichert.`)
};

/**
* | output |
* | --- |
* | "Thanks — your review has been recorded." |
*
* @param {Ticket_Review_ThanksInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_thanks = /** @type {((inputs?: Ticket_Review_ThanksInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_ThanksInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_thanks(inputs)
	if (locale === "ja") return ja_ticket_review_thanks(inputs)
	if (locale === "fr") return fr_ticket_review_thanks(inputs)
	return de_ticket_review_thanks(inputs)
});